<template>
    <div class="StoreListWrap">
        <div class="Order" v-if="orderstate">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>订阅确认</p></div>
                <div class="Return flexa" @click="closeorder"><p>返回</p><img src="../../assets/Home/return.png"></div>
            </div>
            <div class="PayforWrap">
                <!-- 内容 -->
                <div class="OrderContentWrap">
                    <div class="ProductInfo">
                        <i class="Pic"><img :src="productdetailsdata.basedata.logo图"/></i>
                        <div class="Name">
                            <p>{{ productdetailsdata.basedata.名称 }}</p>
                        </div>
                        <div class="Time">
                            <p>{{ productdetailsdata.basedata.标签 }}</p>
                        </div>
                    </div>
                </div>
                <!-- 钱数 -->
                <div class="MoneyCount">
                    <div
                            class="Title flexa"
                            v-if="productdetailsdata.basedata.基础功能介绍"
                    >
                        <p style="width: 50%;text-align: left;margin-right: 0">
                            基础功能
                        </p>
                        <p style="width:49%;margin-right: 0;text-align: right;color:#d5b338">
                            ￥{{ productdetailsdata.basedata.价格 }}/用户/年
                        </p>
                    </div>
                    <div v-if="productdetailsdata.basedata.基础功能介绍">
                        <p
                                style="width: 100%;margin: 0.1rem auto;text-align: left;opacity: 0.8"
                        >
                            {{ productdetailsdata.basedata.基础功能介绍 }}
                        </p>
                    </div>
                    <div class="Title flexa" v-if="Itemlist.length > 0">附加功能</div>
                    <div
                            class="flexbetween"
                            v-for="(item, index) in Itemlist"
                            :key="index"
                             style="margin-top: 0.05rem"
                    >
                        <p style="width: 61.5%;">
                            {{ item.名称 }}
                        </p>
                        <p style="width: 37.5%;margin-right: 0;color:  #d5b338">￥{{ item.价格 }}/用户/年</p>
                    </div>
                    <!--          <div class="Title flexa">选择套餐</div>-->
                    <div class="TypeChooseWrap clearfix" style="margin-top: 0.2rem;margin-bottom: 0.15rem">
                        <div
                                class="Types"
                                v-for="(item, index) in aaasss"
                                :key="index"
                                @click="Chooseaass(item)"
                        >
                            <div class="Choosed">
                                <div class="flexbetween noclick">
                                    <input type="checkbox" v-model="item.选择标识" />
                                </div>
                                <div class="Number">
                                    <p>用户数 {{ item.用户数量 }}</p>
                                </div>
                                <div class="Money">
                                    <p>￥{{ item.金额 }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Title flexa">订单金额</div>
                    <div class="PriceCount1">
                        <div class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                            <div style="width: 60%">
                                <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                    用户数 {{ num }}
                                </p>
                            </div>
                            <div style="width: 40%">
                                <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                    有效期至 {{ mm }}
                                </p>
                            </div>
                        </div>
                        <div style="text-align: right;width: 100%;margin-top: 0.1rem">
                            <span style="font-size: 0.065rem;color: #fff;margin-right: 0.1rem">总金额</span>
                            <span style="font-size:0.075rem;color: #d5b338;"
                            >￥{{ aassdata.金额 }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部汇总 -->
            <div class="Foot">
                <div class="ButtonWrap clearfix">
                    <div class="flex Yes" @click="SubmitOrder"><span>订阅</span></div>
                    <div class="flex No" @click="closeorder"><span>取消</span></div>
                </div>
            </div>
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>{{ titlename }}</p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="Shop flexbetween">
            <div class="ShopName flexa">
                <i><img :src="productdetailsdata.basedata.logo图"></i>
                <div class="Text">
                    <p>{{  productdetailsdata.basedata.名称 }} </p>
                    <p><span>V {{  productdetailsdata.basedata.版本号 }}</span></p>
                    <p class="flexa"><span>{{  productdetailsdata.basedata.标签 }}</span></p>
                </div>
            </div>
            <div class="ButtonWrap  clearfix">
                <p style="font-size: 0.05rem;text-align: right;margin-bottom: 0.05rem">基础价格</p>
                <p style="font-size: 0.06rem;text-align: right;color: #d5b338;font-weight: bold">￥{{ productdetailsdata.basedata.价格 }}/用户/年</p>
            </div>
        </div>
        <div class="ShopText">
            <p
                    v-for="(item,index) in productdetailsdata.basedata.详情介绍.split('。')"
                    :key="index"
                    style="margin-top: 0.1rem"
            >
                {{ item }}
            </p>
        </div>
        <div class="ShopDetails">
            <div class="ShopPic" v-if="productdetailsdata.basedata.详情图"> <img :src="productdetailsdata.basedata.详情图" /></div>
            <div class="MoreContent">
            <div
                 class="Title1"
                 v-if="productdetailsdata.basedata.个性配置"
            >
                <p>个性配置</p>
            </div>
            <div class="CommList" v-if="productdetailsdata.basedata.个性配置">
                <p>{{ productdetailsdata.basedata.个性配置 }}</p>
            </div>
            </div>
            <div class="MoreContent">
                <div
                        class="Title1"
                        v-if="productdetailsdata.basedata.基础功能介绍"
                >
                    <p>基础功能</p>
                </div>
                <div class="CommList" v-if="productdetailsdata.basedata.基础功能介绍">
                    <p>{{ productdetailsdata.basedata.基础功能介绍 }}</p>
                </div>
            </div>
            <div class="MoreContent">
                <div
                        class="Title1"
                        v-if="Itemlist.length > 0"
                >
                    <p>附加功能</p>
                </div>
                <div  v-if="Itemlist.length > 0" >
                <div class="CommList" style="padding: 0.06rem  0.08rem 0.1rem;position: relative" v-for="(item, index) in Itemlist" :key="index">
                    <p class="flexbetween">
                   <span>{{ item.名称 }}</span>
                   <span style="color: #d5b338">￥{{ item.价格 }}/用户/年</span>
                    </p>
                    <p style="margin-top: 0.08rem;width: 80%">{{ item.详情介绍 }}</p>
                    <div class="flex" style="width: 0.35rem;height: 0.13rem;border-radius: 0.4rem;font-size: 0.05rem;color: #fff;position: absolute;right: 0.05rem;top: 0.2rem;background-color: #e7ba2a">已选择</div>
                </div>
                </div>
            </div>
        </div>
        <div class="SubmitOrder clearfix">
            <p>总价 ￥{{ lastmoney1 }}/用户/年</p>
            <div class="Button flex" @click="openorder">订阅</div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="buystate">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请支付...</p></div>
                    <div class="CloseBox" @click="closepay('Web_WechatOrderQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div v-if="!payss">
                      <div class="CodeWrap">
                     <!--   <img :src="code">-->
                        <img :src="code">
                    </div>
                      <div class="flex Tip"><p>请使用微信扫描二维码支付</p></div>
                      <div class="flex ReButton" @click="Check('Web_WechatOrderQuery')">支付成功后点击这里刷新</div>
                    </div>
                    <div v-else class="flex" style="width: 100%;height:70%">
                        <i   @click="SubmitOrderData('M0042510000000000000000002')"  style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/al.png"></i>
                        <i   @click="SubmitOrderData('M0042510000000000000000001')" style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/wx.png"></i>
                    </div>
                    <div v-if="payss" class="flex ReButton" style="cursor: auto">请选择支付方式</div>
                </div>
            </div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="alstate">
            <div class="Login">
                <div class="LoginContentWrap" style="width: 1.8rem;height: 1.5rem">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 正在支付中...</p></div>
                    <div class="CloseBox" @click="closepay('Web_AlipayTradeQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div style="margin-top: 0.4rem">
                        <div class="flex Tip"><p>支付完成前请不要关闭此验证窗口</p></div>
                        <div class="flex ReButton" @click="Check('Web_AlipayTradeQuery')">支付成功后点击这里刷新</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  // eslint-disable-next-line no-unused-vars
  import { mapGetters } from 'vuex';
  export default {
    name: 'storelist',
    props: {
      flag: [String, Number],
      productdetailsdata: Object,
      classid: String,
      titlename: String
    },
    inject: [
      'load'
    ],
    data() {
      return {
        buystate: false,
        payss: true,
        code: '',
        alstate: false,
        orderstate: false,
        Itemlist: [],
        Item_list: [],
        ProductData: {},
        chooseitems: [],
        aaasss: [],
        aassdata: {},
        lastmoney1: 0,
        mm: '',
        lastmoney: 0,
        orderNumber: '',
        num: 1
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo', 'currentSystem'])
    },
    methods: {
      Check(param) {
        this.load.show();
        this.$utils.CheckPayfor(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId, param).then(res => {
          console.log(res);
          this.load.hide();
          if (res.data.code === 0) {
            this.$confirm('支付成功！请前往“个人中心-注册平台”进行企业注册！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '返回',
              showClose: false,
              closeOnClickModal: false,
              type: 'success'
            }).then(() => {
              this.$router.push({
                name: 'PersonCenter'
              });
            }).catch(() => {
              this.GetOrderList('待支付', 1);
            });
          } else {
            this.$confirm('您还没有支付成功！是否继续支付？', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              closeOnClickModal: false,
              type: 'error'
            }).then(() => {
              console.log('未支付');
            }).catch(() => {
              this.$confirm('"您已取消支付!请尽快到个人中心我的订单-待支付中完成支付"', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push({
                  name: 'Order',
                  params: { orderstate: '待支付', index: 1 }
                });
              }).catch(() => {
                console.log('取消');
                this.buystate = false;
                this.payss = true;
                this.alstate = false;
              });
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message.error(error);
        });
      },
      closepay(params) {
        this.Check(params);
      },
      currentDateLater() {
        var date = new Date();
        var y = date.getFullYear() + 1;
        var m = date.getMonth() + 1;
        // m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        // d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        /*     var second = date.getSeconds(); */
        minute = minute < 10 ? '1' + minute : minute;
        /*      second = second < 10 ? "0" + second : second; */
        this.mm = y + '-' + m + '-' + d + ' ' + h + ':' + minute;
      },
      Chooseaass(item) {
        console.log(item);
        this.aassdata = item;
        for (let i = 0; i < this.aaasss.length; i++) {
          this.aaasss[i].选择标识 = false;
        }
        item.选择标识 = true;
        this.num = item.用户数量;
      },
      Getdjjd() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007036',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 产品ID: this.productdetailsdata.basedata.产品ID }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              this.aaasss = res.data.data.DETAIL;
              this.Chooseaass(this.aaasss[0]);
              this.orderstate = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
      },
      /* 支付前提交支付信息平台(选取支付平台最终支付调用) */
      SubmitOrderData(num) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007010',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: this.orderNumber,
            headData: {
              支付平台: num
            },
            saveGridData: 1,
            gridData: this.chooseitems
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              if (num === 'M0042510000000000000000007') {
                /* 苹果支付 */
              } else if (num === 'M0042510000000000000000002') {
                /* 支付宝 */
                this.$utils.AliPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.alstate = true;
                  this.buystate = false;
                  // eslint-disable-next-line no-useless-escape
                  window.open(res.data.data, '_blank');
                  console.log(res.data);
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              } else {
                /* 微信 */
                this.$utils.WXPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.payss = false;
                  this.alstate = false;
                  console.log(res);
                  this.code = res.data.data;
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              }
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 生成订单 */
      CreateOrder() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007009',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            headData: {
              产品ID: this.productdetailsdata.basedata.产品ID,
              定制: 0,
              开发账户: this.productdetailsdata.basedata.开发账户,
              产品分类ID: this.classid,
              定价方案ID: this.aassdata.定价方案ID
            },
            saveGridData: 1,
            gridData: this.chooseitems
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.orderNumber = res.data.data.orderNumber;
              this.buystate = true;
              this.load.hide();
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      SubmitOrder() {
        this.chooseitems = [];
        for (let i = 0; i < this.Itemlist.length; i++) {
          let obj = {};
          obj['定制项ID'] = this.Itemlist[i].定制项ID;
          obj['产品ID'] = this.Itemlist[i].产品ID;
          this.chooseitems.push(obj);
        }
        this.CreateOrder();
      },
      openorder() {
        if (this.LoginUserInfo.userId) {
          this.Getdjjd();
          this.currentDateLater();
        } else {
          this.$emit('OpenLoginBox');
        }
      },
      closeorder() {
        this.orderstate = false;
      },
      Return() {
        this.$emit('CloseProductBox');
      }
    },
    created() {
      console.log(this.productdetailsdata);
      if (this.productdetailsdata.itemlist.length > 0) {
        var arr = [];
        var _arr = [];
        let m = 0;
        for (let i = 0; i < this.productdetailsdata.itemlist.length; i++) {
          console.log(this.productdetailsdata.itemlist[i]);
          this.productdetailsdata.itemlist[i].选择标识 = true;
          if (this.productdetailsdata.itemlist[i].基础功能 === '0') {
            arr.push(this.productdetailsdata.itemlist[i]);
            m = this.$utils.accAdd(m, this.productdetailsdata.itemlist[i].价格);
          } else {
            _arr.push(this.productdetailsdata.itemlist[i]);
          }
        }
        this.lastmoney1 = this.$utils.accAdd(
          m,
          this.productdetailsdata.basedata.价格
        );
        this.Itemlist = arr;
        this.Item_list = _arr;
        console.log(this.Itemlist);
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .StoreListWrap{
        width: 100%;
        .BuyBox{
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 4;
            .Login {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.6);
                z-index: 4;
                display: flex;
                -webkit-justify-content: center;
                -webkit-align-items: center;
                .LoginContentWrap {
                    width: 2.7rem;
                    height: 2.78rem;
                    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
                    background: linear-gradient(to bottom right, #6666cc, #4141b3);
                    position: relative;
                    .CloseBox {
                        width: 0.15rem;
                        height: 0.15rem;
                        position: absolute;
                        cursor: pointer;
                        right: 0.05rem;
                        top: 0.05rem;
                        z-index: 4;

                        img {
                            width: 100%;
                        }
                    }
                    .NeedKnown {
                        position: absolute;
                        width: 100%;
                        bottom: 0.1rem;

                        p {
                            font-size: $SmallTextSize;
                            color: #fff;
                            text-align: center;

                            span {
                                cursor: pointer;
                                font-weight: bold;
                                margin: 0 0.02rem;
                                color: #999900;
                            }
                        }
                    }
                    .LoginTitle {
                        width: 100%;
                        margin-top: 0.05rem;

                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-indent: 0.05rem;
                        }
                    }
                }
            }
            .ReButton{
                width: 1.3rem;
                height: 0.2rem;
                background-color: #9797ff;
                color: #fff;
                font-size: $TextSize;
                margin: 0.3rem auto 0;
                border-radius: 0.2rem;
                cursor: pointer;
            }
            .CodeWrap{
                width: 1.3rem;
                height: 1.3rem;
                background-color: #fff;
                margin: 0.3rem auto 0.1rem;
                border: 0.02rem solid #fff;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .Tip{
                width: 100%;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin: 0 0.03rem;
                }
                p:last-child{
                    font-size: $TextSize;
                    font-weight: bold;
                    color: #ceceff;
                }
            }
        }
        .Foot {
            width: 100%;
            height: 0.6rem;
            .ButtonWrap {
                width: 90%;
                margin: 0 auto;
                position: relative;
                div:last-child {
                    margin-left: 0 !important;
                }
                .Yes,
                .No {
                    width: 0.8rem;
                    height: 0.25rem;
                    float: right;
                    margin-left: 0.1rem;
                    background-color: #26a2ff;
                    border-radius: 0.8rem;
                    cursor: pointer;
                    span {
                        font-size: $TextSize;
                        color: #fff;
                    }
                }
                .Yes {
                    background-color: #8c73b5;
                }
                .No {
                    background-color: #666666;
                }
            }
            .Count {
                width: 6.3rem;
                height: 0.8rem;
                margin: 0 auto;
                p {
                    font-size: 0.32rem;
                    text-align: right;
                    font-weight: bold;
                    color: #666666;
                }
            }
        }
        .PayforWrap {
            width: 90%;
            margin: 0 auto;
            .ChooseComp {
                width: 100%;
                padding: 0.2rem 0;
                ul {
                    width: 100%;
                    overflow-x: scroll;
                    overflow-scrolling: touch;
                    height: 1rem;
                    text-align: left;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    white-space: nowrap;
                    overflow-y: hidden;
                    li {
                        width: 1rem;
                        height: 0.3rem;
                        background-color: #666666;
                        display: inline-block;
                        margin-right: 0.02rem;
                        border-radius: 0.03rem;
                        div {
                            width: 100%;
                            height: 100%;
                        }
                        p {
                            font-size: $TextSize;
                            color: #fff;
                        }
                    }
                    li.Active {
                        background-color: #8c73b5;
                    }
                }
            }
            .MoneyCount {
                width:100%;
                margin: 0.05rem auto 0;
                padding-bottom: 0.1rem;
                .Times {
                    width: 98%;
                    margin: 0.02rem auto;
                    div {
                        font-size: $AdditionTextSize;
                        width: 1rem;
                        float: left;
                        margin-bottom: 0.04rem;
                        input {
                            width: 0.1rem;
                            height: 0.1rem;
                            border-radius: 0.1rem;
                            margin-right: 0.05rem;
                        }
                    }
                }
                .TypeChooseWrap {
                    width: 100%;
                    .Types,
                    .TypesMore {
                        width: 0.8rem;
                        height: 0.5rem;
                        margin-right: 0.04rem;
                        border-radius: 0.08rem;
                        cursor: pointer;
                        background-color: #dee7eb;
                        float: left;
                        .Choosed {
                            box-sizing: border-box;
                            .Money {
                                width: 90%;
                                margin:0 auto;
                                p {
                                    width: 94%;
                                    text-align: right;
                                    font-size: $SmallTitleSize;
                                    color: #626262;
                                    font-weight: bold;
                                }
                            }
                            .Number {
                                width: 90%;
                                margin: 0.05rem auto 0.08rem;
                                p {
                                    font-size: $SmallTitleSize;
                                    font-weight: bold;
                                    width: 100%;
                                    text-align: left;
                                }
                            }
                            p {
                                font-size: $AdditionTextSize;
                                color: #414141;
                            }
                            input {
                                width: 0.1rem;
                                height: 0.1rem;
                                border-radius: 0.04rem;
                                margin: 0.05rem 0 0 0.05rem;
                            }
                        }
                    }
                    > div:nth-child(4n) {
                        margin-right: 0;
                    }
                }
                .Title {
                    width: 100%;
                    height: 0.15rem;
                    font-size: $TextSize;
                    color: #fff;
                    border-bottom: 1px solid #c9c9c9;
                }
                div {
                    width: 98%;
                    margin: 0 auto;
                    p {
                        font-size: $TextSize;
                        color: #fff;
                        text-align: right;
                        width: 40%;
                        margin-right: 0.1rem;
                    }
                    p:first-child {
                        width: 58%;
                    }
                }
            }
            &::-webkit-scrollbar {
                display: none;
            }
            .OrderContentWrap {
                width:100%;
                margin: 0 auto;
                .ProductInfo {
                    width: 100%;
                    margin: 0 auto;
                    padding-bottom: 0.05rem;
                    padding-top: 0.05rem;
                    position: relative;
                    .Name {
                        margin-top: 0.05rem;
                        p {
                            font-size: $SmallTitleSize;
                            font-weight: bold;
                            color: #fff;
                        }
                    }
                    .Time {
                        margin-top: 0.05rem;
                        p {
                            font-size: $SmallTextSize;
                            color: #fff;
                            opacity: 0.8;
                        }
                    }
                    .Intro {
                        margin-top: 0.05rem;
                        p {
                            font-size: $TextSize;
                            color: #666;
                        }
                    }
                    .Pic {
                        width: 0.4rem;
                        height: 0.4rem;
                        border-radius: 0.1rem;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 0.1rem;
                        }
                    }
                }
            }
            .Step {
                width: 100%;
                .StepList {
                    width: 100%;
                    margin-bottom: 0.1rem;
                    .Time {
                        width: 0.4rem;
                        p {
                            font-size: $TextSize;
                            text-align: left;
                        }
                    }
                    .Text {
                        width: 2.5rem;
                        .TextContent {
                            margin-left: 0.08rem;
                            width: calc(100% - 0.08rem - 10px);
                            p {
                                font-size: $TextSize;
                                color: #666666;
                                font-weight: bold;
                            }
                        }
                        i {
                            width: 10px;
                            height: 10px;
                            background-color: #bb4b47;
                            border-radius: 10px;
                            margin-top: 0.02rem;
                        }
                    }
                }
            }
            .NumberWrap {
                width: 100%;
                p {
                    font-size: $TextSize;
                    color: #414141;
                }
            }
        }
        .Order{
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 3;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .SubmitOrder{
            width: 90%;
            margin: 0.4rem auto;
            .Button{
                width: 0.8rem;
                height: 0.25rem;
                border-radius: 0.6rem;
                background-color: #cc3333;
                float: right;
                font-size: $TextSize;
                color: #fff;
                margin-top: 0.1rem;
                cursor: pointer;
            }
            p{
                font-size: 0.06rem;
                text-align: right;
                color: #d5b338;
                font-weight: bold;
                margin-right: 0.06rem;
            }
        }
        .MoreContent{
            .Title1 {
                width: 100%;
                margin: 0.12rem auto 0.08rem;
                p {
                    font-size: $SmallTitleSize;
                    color: #fff;
                }
            }
            .CommList {
                border-radius: 0.07rem;
                border: 1px solid #fff;
                box-sizing: border-box;
                padding: 0.12rem 0.08rem 0.1rem;
                p {
                    font-size: $TextSize;
                    color: #fff;
                    line-height: 0.09rem;
                }
            }
        }
        .ShopDetails{
            width: 90%;
            margin: 0 auto;
            .ShopPic{
                width: 100%;
                margin-top: 0.05rem;
                img{
                    width: 100%;
                    border-radius: 0.1rem;
                }
            }
        }
        .ShopText{
            width: 90%;
            margin: 0.05rem auto 0;
            p{
                font-size: $TextSize;
                color: #fff;
                line-height: 0.1rem;
            }
        }
        .Shop{
            width: 90%;
            margin: 0.1rem auto 0;
            .ButtonWrap{
               p{
                   color: #fff;
                   font-size: $AdditionTextSize;
               }
            }
            .ShopName{
                i{
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.05rem;
                    margin-right: 0.05rem;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.05rem;
                    }
                }
                .Text{
                    p:first-child{
                        font-size: $TextSize;
                        font-weight: bold;
                        color: #fff;
                        margin-bottom: 0.05rem;
                        margin-top: 0.02rem;
                    }
                    p:last-child{
                        margin-top: 0.03rem;
                    }
                    p:nth-child(2), p:last-child{
                        font-size: $AdditionTextSize;
                        color: #fff;
                        opacity: 0.6;
                        span{
                            margin-right: 0.02rem;
                        }
                    }
                }
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
    }
</style>
